import React from "react";
import {
  useQueryRessTraces,
  useSubscribeRessTraceUpdate,
} from "../../../utils/graphql/hooks/ressHooks";

export default function RESSDataManager() {
  useQueryRessTraces();
  useSubscribeRessTraceUpdate();
  return <></>;
}
